module.exports = __webpack_public_path__ + "img/stylefalse.ab1c881d.png";